// extracted by mini-css-extract-plugin
export default {"root":"_25955","cover":"_194H6","middle":"_1xZu0","mature-block":"_1wXEB","matureBlock":"_1wXEB","underlay":"_3civV"};